import { render, staticRenderFns } from "./EditOrgMember.vue?vue&type=template&id=282f6134&scoped=true"
import script from "./EditOrgMember.vue?vue&type=script&lang=js"
export * from "./EditOrgMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f6134",
  null
  
)

export default component.exports